module.exports = __webpack_public_path__ + "static/lips-1df23633c520afda3cb73a0ae3264692.jpeg";